/* eslint-disable jira/filename-case */
import React, { type PropsWithChildren } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useIsClientReady } from './hooks/use-is-client-ready.tsx';

export type RenderOnClientProps = PropsWithChildren<{ fg?: string }>;

const RenderWhenReady = ({ children }: PropsWithChildren) => {
	const isClientReady = useIsClientReady();
	if (isClientReady) {
		return children;
	}

	return null;
};

/**
 * Renders children only on the client side.
 *
 * @param children - The children to render.
 * @param fg - The feature gate name.
 */
export const RenderOnClient = ({
	children,
	fg: featureGateName,
}: RenderOnClientProps):
	| string
	| number
	| boolean
	| Iterable<React.ReactNode>
	| React.JSX.Element
	| null
	| undefined => {
	// eslint-disable-next-line jira/ff/static-feature-flags
	if (featureGateName && !fg(featureGateName)) {
		return children;
	}

	return <RenderWhenReady>{children}</RenderWhenReady>;
};
